import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      cursor: 'pointer',

      '&:hover': {
        background: COLORS.primary.silver,

        '& $hiddenIcon': {
          visibility: 'visible',
        },
      },
    },
    cell: {
      borderBottom: theme.shape.borderGray60,
    },
    cellFavorite: {
      padding: theme.spacing(1.5),
      '& svg': {
        fontSize: theme.typography.pxToRem(16),
      },
    },
    cellName: {
      padding: theme.spacing(2),
    },
    cellType: {
      padding: theme.spacing(2),
    },
    cellDescription: {
      padding: theme.spacing(2),
    },
    cellMenu: {
      padding: theme.spacing(1),
      width: 0,
    },
    contentName: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    icon: {
      fontSize: theme.typography.pxToRem(20),
      color: COLORS.gray.gray30,
    },
    hiddenIcon: {
      visibility: 'hidden',
    },
    favoriteIcon: {
      padding: theme.spacing(0.5),
    },
  }),
  { name: 'ProjectTableRows' }
);
